import { withLinks } from "./link";
import { withImages } from "./image";
import withHr from "./hr";
import withShortcuts from "./shortcuts";
import { withList } from "./list";
import { withCodeBlock } from "./codeBlock";
import { withBlockquote } from "./blockquote";
import { withHtml } from "./html";

export default [
  withHtml,
  // withLinks,
  withImages,
  withHr,
  withShortcuts,
  withList,
  withCodeBlock,
  withBlockquote
];
